<template>
    <div class="c-event-filters-container" v-if="!containsExclusionParameters">

        <Loader v-if="isLoading"/>

        <div class="c-filter-section__toggle">
            <button class="c-filter-section__mobile-toggle c-btn c-btn--primary c-btn--small" aria-label="Toggle Filters">Filters <i class="far fa-angle-down"></i></button>
            <button type="submit" v-if="isFiltered" @click="resetFilters" class="c-btn c-btn--small c-btn--ghost c-event-filters__reset-button c-event-filters__mobile-reset-button"><i class="far fa-times"></i> Clear All Filters</button>
        </div>

        <section class="c-filter-section">
            <div class="c-event-filters">
                <DateRangeFilter />
                <div class="c-event-filters__dropdowns">
                    <div class="c-event-category-filter">
                        <label>Event Type</label>
                        <SelectFilter class="c-dropdown" taxonomy="event-category" />
                    </div>
                    <div class="c-event-audience-filter">
                        <label>Audience</label>
                        <SelectFilter class="c-dropdown" taxonomy="event-audience" />
                    </div>
                    <SearchInput @enterKeyPressed="applyFilters" />
                </div>

                <div class="c-event-filters__actions">
                    <div class="c-filter-actions">
                        <button type="submit" @click="applyFilters" class="c-btn c-event-filters--apply">Filter Events</button>
                    </div>
                </div>
            </div>
        </section>

        <div class="c-event-filters__desktop-reset">
            <button type="submit" v-if="isFiltered" @click="resetFilters" class="c-btn c-btn--small c-btn--ghost c-event-filters__desktop-reset-button"><i class="far fa-times"></i> Clear All Filters</button>
        </div>

    </div>
</template>

<script>
    import DateRangeFilter from "./DateRangeFilter"
    import Loader from "./Loader"
    import SelectFilter from "./SelectFilter";
    import SearchInput from "./SearchInput";

    export default {
        name: "FilterGroup",
        props: {
            submitUrl: {
                type: String,
                required: true
            },
            exclusions: {
                type: Array,
                default: [],
            }
        },
        components: {
            DateRangeFilter,
            Loader,
            SelectFilter,
            SearchInput,
        },
        computed: {
            isLoading() {
                // Gets the loading status
                return this.$store.getters.loadingStatus
            },
            isFiltered() {
                // check to see if there are any filters applied
                return window.location.search.length > 0
            },
        },
        data() {
            return {
                containsExclusionParameters: false
            }
        },
        mounted() {
            this.checkUrlParamsContainExclusions()
        },
        methods: {
            applyFilters() {
                // Applies the filter to the url upon submission
                let selectedFieldValues = this.$store.getters.allFields,
                    urlParams = Object.keys(selectedFieldValues).map((key) => {
                        return encodeURIComponent(key) + '=' + encodeURIComponent(selectedFieldValues[key])
                    }).join('&');

                if (urlParams.length > 0) {
                    window.location =  this.submitUrl + '?' +urlParams
                } else {
                    window.location =  this.submitUrl
                }

            },
            checkUrlParamsContainExclusions() {
                const urlParams = new URLSearchParams(window.location.search);

                this.exclusions.forEach(value => {
                    if (urlParams.has(value)) {
                        this.containsExclusionParameters = true
                    }
                })
            },
            resetFilters() {
                window.location = window.location.origin + '/' + window.location.pathname
            }
        }
    }
</script>

<style scoped>

</style>
